/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


function required_form(required_field) {
    // console.log(required_field);
    required_field = document.getElementById(required_field);
    required_field.required = true;
    var required_star = required_field.id + '_label';
    //console.log (required_field);
    if (document.getElementById(required_star) !== null) {
        document.getElementById(required_star).innerHTML += ' <strong><font color=red>*</font></strong>';
    }
}

function required_form2(cat_field) {
    console.log(cat_field);
    cat_field = document.getElementById(cat_field);
    cat_field.required = true;
    //console.log(cat_field);
}

function required_form3(tax) {
    tax = document.getElementById(tax);
    tax.required = true;
}

function required_label(cat_name) {
    console.log(cat_name);
    cat_name = document.getElementById(cat_name);
    cat_name.innerHTML += ' <strong><font color=red>*</font></strong>';
}


function liste_taxa(rep_array) {

    var i = 0;
    var j = 0;

    for (i in rep_array) {
        listener = document.getElementById(rep_array[i]);
        /* jshint ignore:start */
        listener.addEventListener("change", function () {
            //console.log (listener);
            for (j in rep_array) {
                listener2 = document.getElementById(rep_array[j]);
                listener2.required = false;
                listener2.disabled = true;
                //console.log (listener2);
            }
            if (this.checked === true) {
                //console.log(this);
                this.required = true;
                this.disabled = false;
            }
            if (this.checked === false) {
                for (var k in rep_array) {
                    listener3 = document.getElementById(rep_array[k]);
                    listener3.disabled = false;
                    listener3.required = true;
                }
            }
        });
        /* jshint ignore:end */
    }
}

function error_conf(div_to_replace, msg_error) {
    document.addEventListener('DOMContentLoaded', function () {
        document.getElementById(div_to_replace).innerHTML = msg_error;
    });
}

(function checkDate(){
    document.addEventListener ('DOMContentLoaded', function () {
        console.log(dateFields);
        for(var i = 0; i<dateFields.length; i++) {
            if(document.getElementById(dateFields[i])){
                document.getElementById(dateFields[i]).addEventListener('blur', function (dateField){
                    console.log('changed');
                    checkFormatDate(dateField.target);
                });
            }
        }

    });
})();


function checkFormatDate(dateField){
    var regExpWireFormat = /^(19|20)\d\d[- \/.](0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])$/;
    var regExp = /(^(((0[1-9]|1[0-9]|2[0-8])[\/](0[1-9]|1[012]))|((29|30|31)[\/](0[13578]|1[02]))|((29|30)[\/](0[4,6,9]|11)))[\/](19|[2-9][0-9])\d\d$)|(^29[\/]02[\/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
    var notValidDate = false;
    if(!dateField.value){
        dateField = document.getElementById(dateField.id);
    }
    // var dateField = document.getElementById(dateFields);
    if(!regExp.test(dateField.value)){
        notValidDate = true;
        if(regExpWireFormat.test(dateField.value)){
            notValidDate = false;
        }
    }
    console.log('Date non valide : ' + notValidDate);
    if(notValidDate){
        dateField.setCustomValidity('Invalid');
        document.getElementById('date_error').style.display = 'block';
    } else {
        dateField.setCustomValidity('');
        document.getElementById('date_error').style.display = 'none';
    }
}